import React from 'react';
import GlobalAlertBanner from '@components/global-alert-banner';

type ReturnType<T> = (props: T) => React.JSX.Element;

export const withGlobalAlertBanner = <T extends object>(Component: React.ComponentType<T>): ReturnType<T> => {
    return (props: T) => (
        <>
            <GlobalAlertBanner />
            <Component {...props} />
        </>
    );
};
